<template>
	<div class="bordered-card">
        <div v-if="title" class="title text weight-600">{{ title }}</div>
        
        <Card v-else>
            <template v-slot:content>
                <EtablishmentTime 
                    :hour="hour"
                    :minute="minute"
                />
            </template>
        </Card>
        <div class="pt-2 subtitle">{{ subtitle }}</div>
    </div>
</template>

<script type="text/javascript">
  import EtablishmentTime from '@/components/ui/etablishment-time'

    export default {
        name: 'color-marker',
        components: {
            EtablishmentTime,
        },
        props : {
            title : {
                type : String,
                default : ''
            },
            subtitle : {
                type : String,
                default : ''
            },
            hour : {
                type : String,
                default : ''
            },
            minute : {
                type : String,
                default : ''
            },
        },
        data () {
            return {
                
            }
        },
        computed : {
            
        },
        created () {
            
        },
        methods : {
            
        }
    }

</script>

<style lang="scss">
    .bordered-card {
        height: 171px;
        background-color: $blue-light-button;
        border-radius: 10px;
        text-align: center;
        display: table-cell;
        padding: 35px 40px;
        border: 1px solid $purple-card-border !important;
        .title {
            color: $purple-alt;
            font-size: 40px !important;
            font-weight: 700;
        }
        .subtitle {
            font-size: 20px !important;
            color: $black-alt-lighten-1;
        }
    }
</style>